import { Mui, MuiIcons } from '@osu/react-ui';
import ScholarsDashboardLink from '../../../Common/components/ScholarsDashboardLink';

/**
 * NoApplicationsComponent
 * Displays when no application data is found
 */
function NoApplicationsComponent() {
  return (
    <Mui.Paper 
      elevation={2} 
      sx={{ 
        p: 4, 
        textAlign: 'center', 
        mb: 4, 
        backgroundColor: 'rgba(255, 193, 7, 0.04)', 
        border: '1px solid rgba(255, 193, 7, 0.2)' 
      }}
      component="section"
    >
      <Mui.Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        <MuiIcons.InfoOutlined sx={{ fontSize: "inherit", mr: 1, color: 'warning.main' }} />
        <Mui.Typography variant="h3" sx={{ color: 'warning.main' }}>
          No Application in System
        </Mui.Typography>
      </Mui.Box>
      
      <Mui.Typography variant="body1" paragraph>
        You do <strong>not</strong> have an active University Honors Program application under review.
      </Mui.Typography>
      
      <Mui.Typography variant="body1" paragraph>
        You must first be <strong>admitted</strong> to the Columbus campus of The Ohio State University to proceed with Honors review.
      </Mui.Typography>


      
      <section>
      <Mui.Typography id="applied-for-scholars" variant="body1" paragraph className="display-flex flex-direction-column">
        Applied for Ohio State Scholars? Interested in learning more? 
      </Mui.Typography>
      <ScholarsDashboardLink sx={{ mb: 2 }}/>

      </section>
      <Mui.Divider />
      <Mui.Typography variant="h4" sx={{ my: 2 }}>
        Questions?
      </Mui.Typography>
      <Mui.Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Mui.Button
          variant="outlined"
          color="secondary"
          startIcon={<MuiIcons.AttachEmail />}
          component={Mui.Link}
          href="tel:614-292-3135"
          sx={{ minWidth: 200, textTransform: "none" }}
        >
          Call (614) 292-3135
        </Mui.Button>
        <Mui.Button
          variant="outlined"
          color="secondary"
          startIcon={<MuiIcons.AttachEmail />}
          component={Mui.Link}
          href="mailto:honors-scholars@osu.edu"
          sx={{ minWidth: 200, textTransform: "none" }}
        >
          Email honors-scholars@osu.edu
        </Mui.Button>
      </Mui.Box>
    </Mui.Paper>
  );
}

export default NoApplicationsComponent;